import React, { Component } from "react";
import {Link,Redirect} from 'react-router-dom';
import Hero from '../../components/Hero';
import SingleProductImg from '../../images/singleProductBcg.jpeg';
import {ProductConsumer} from '../../context';


export default class AdminAddProduct extends Component {
	render() {
		return (
			<>
				<Hero img={SingleProductImg} title="Tilføj Produkt"/>
				<ProductConsumer >
					{value=>{
						const{handleChange,addProduct,price,price1,price2,category,menu,productName,productNr,productTopping,haslogged}=value;

						const priceShow = ()=>{

							switch (category) {
								case "Klassisk PIZZA":
									return (	
									<div className="row">
										<div className="col-md-6">
											<div className="md-form mb-0">
												<input 
													type="number" 
													id="price" 
													min="1"
													max="999"
													name="price" 
													className="form-control"
													onChange={handleChange}
													value={price}/>
												<label htmlFor="price" className="">Pris</label>
											</div>
									   	</div>
										<div className="col-md-6">
											<div className="md-form mb-0">
												<input 
													type="number" 
													id="price1" 
													min="1"
													max="999"
													name="price1" 
													className="form-control"
													onChange={handleChange}
													value={price1}/>
												<label htmlFor="price1" className="">Pris 2</label>
											</div>
									   	</div>
									
									<div className="col-md-6">
										<div className="md-form mb-0">
											<input 
											type="number" 
											min="1"
											max="999"
											id="price2" 
											name="price2" 
											className="form-control"
											onChange={handleChange}
											value={price2}/>
											<label htmlFor="price2" className="">Pris 3</label>
										</div>
									</div>
									<div className="col-md-6">
										<div className="md-form mb-0">
											<input 
												type="text" 
												id="productTopping" 
												name="productTopping" 
												className="form-control"
												onChange={handleChange}
												value={productTopping}/>
											<label htmlFor="productTopping" className="">Topping</label>
										</div>
									</div>
								</div>
								)
									
							
								case "Burgers":
									return(
										<div className="row">
										<div className="col-md-6">
											<div className="md-form mb-0">
												<input 
													type="number" 
													id="price" 
													min="1"
													max="999"
													name="price" 
													className="form-control"
													onChange={handleChange}
													value={price}/>
												<label htmlFor="price" className="">Pris</label>
											</div>
									   	</div>
										   <div className="col-md-6">
											<div className="md-form mb-0">
												<input 
													type="number" 
													id="price1" 
													min="1"
													max="999"
													name="price1" 
													className="form-control"
													onChange={handleChange}
													value={price1}/>
												<label htmlFor="price1" className="">Pris 2</label>
											</div>
									   	</div>
								</div>
									)

								case "Pasta":
									return(
								<div className="row">
										<div className="col-md-6">
											<div className="md-form mb-0">
												<input 
													type="number" 
													id="price" 
													min="1"
													max="999"
													name="price" 
													className="form-control"
													onChange={handleChange}
													value={price}/>
												<label htmlFor="price" className="">Pris</label>
											</div>
									   	</div>
								
									<div className="col-md-6">
										<div className="md-form mb-0">
											<input 
												type="text" 
												id="productTopping" 
												name="productTopping" 
												className="form-control"
												onChange={handleChange}
												value={productTopping}/>
											<label htmlFor="productTopping" className="">Topping</label>
										</div>
									</div>
								</div>
									)
								default:
									break;
							}
						}
						if(haslogged){
							let companies = new Set();
							for (let product in menu) {
								companies.add(menu[product]["category"]);
							}
							companies = [ ...companies ];
								return <section className='py-5'>
											<div className='contanier'>
												<div className='row ml-3'>
													<div className='col-10 mx-auto col-sm-8 col-md-6 my-3'>
														<form id="contact-form" method="POST">
															<div>
																<label htmlFor="kategorie">Kategori</label>
																<select
																	name="category"
																	id="category"
																	className="filter-item"
																	onChange={handleChange}
																	value={category}
																>
																	{companies.map((category, index) => {
																		return (
																			<option key={index} value={category}>
																				{category}
																			</option>
																		);
																	})}
																</select>
															</div>

										
															<div className="row">
																<div className="col-md-6">
																	<div className="md-form mb-0">
																		<input 
																			type="number"
																			min="1"
																			max="999" 
																			id="productNr" 
																			name="productNr" 
																			className="form-control"
																			onChange={handleChange}
																			value={productNr}/>
																		<label htmlFor="productNr" className="">Nr</label>
																	</div>
																</div>
																<div className="col-md-6">
																	<div className="md-form mb-0">
																		<input 
																			type="text" 
																			id="productName" 
																			name="productName" 
																			className="form-control"
																			onChange={handleChange}
																			value={productName}/>
																		<label htmlFor="productName" className="">Navn</label>
																	</div>
																</div>
															</div>		
														{priceShow() }
														</form>

													</div>
													<div className='col-10 mx-auto col-sm8 col-md-6 my-3'>
														<button type='button' className='main-link' style={{margin:'0.75rem'}} onClick={()=>addProduct()}>Tilføj</button>
														<Link to='/admin' className='main-link' style={{margin:'0.75rem'}}>Tilbage til Kontrolpanel</Link>	
													</div>
												</div>
											</div>
										</section>
						}else{
							return(<Redirect to="/admin"/>)
						}
					}}

				</ProductConsumer>
			</>
		);
	}
}
